import * as amplitude from "@amplitude/analytics-browser";
import appConfig from "../app.config";

function initAmplitude() {
  return new Promise((resolve, reject) => {
    if (process.env.NODE_ENV === "development" || !appConfig.AMPLITUDE_API_KEY) return resolve({ status: "Uninitiated" });
    amplitude.init(appConfig.AMPLITUDE_API_KEY, {
      autocapture: false,
      appVersion: process.env.VERSION,
    });
    resolve({ status: "Initiated" });
  });
}

initAmplitude()
  .then((res) => {
    console.log(res);
  })
  .catch((err) => {});

interface AmplitudeUser {
  id: string;
  name?: string;
  email?: string;
  role?: string;
  phoneNumber?: string;
  tenantId?: string;
}

export function setAmplitudeUser(user: AmplitudeUser) {
  amplitude.setUserId(user.id);

  const identify = new amplitude.Identify();
  const { name, email, role, phoneNumber, tenantId } = user;

  if (name) identify.set("name", name);
  if (email) identify.set("email", email);
  if (role) identify.set("role", role);
  if (phoneNumber) identify.set("phonenumber", phoneNumber);
  if (tenantId) identify.set("tenantId", tenantId);

  amplitude.identify(identify);
}

export function clearAmplitudeUser() {
  amplitude.reset();
}
